import ProductCreate from './ProductCreate'
export {ProductCreate}
export default ProductCreate
